import Head from 'next/head'
import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next/pages'
import { Breadcrumb } from 'pcl-ui'
import React from 'react'
import ReactMarkdown from 'react-markdown'
import i18nextConfig from '@/next-i18next.config'
import { config } from '@/site.config'
import { PageTitle } from './PageTitle'

export function Article({ contentId }: { contentId: string }) {
  const { t } = useTranslation(['common', 'articles-listing', contentId])
  const router = useRouter()

  const homeHref =
    router.query.locale &&
    router.query.locale !== i18nextConfig.i18n.defaultLocale
      ? `/${router.query.locale}`
      : '/'

  const articlesHref =
    router.query.locale &&
    router.query.locale !== i18nextConfig.i18n.defaultLocale
      ? `/${router.query.locale}/articles`
      : '/articles'
  const pageTitle = t(`articles-listing:articles.${contentId}.title` as never)
  const emphasisClass = ['ja', 'ko'].includes(router.query.locale as string)
    ? ''
    : 'italic'

  return (
    <div className="relative overflow-hidden bg-transparent">
      <PageTitle>{pageTitle}</PageTitle>
      <Head>
        <meta
          name="description"
          content={t(
            `articles-listing:articles.${contentId}.description` as never,
          )}
        />
        <meta
          property="og:description"
          content={t(
            `articles-listing:articles.${contentId}.description` as never,
          )}
        />
        <meta property="og:title" content={pageTitle} />
        <meta
          property="og:url"
          content={`${config.prodDomain}${router.asPath}`}
        />
        <meta property="og:site_name" content={t('title')} />
      </Head>
      <article className="relative py-8 px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-prose">
          <Breadcrumb
            className="mb-6"
            ariaLabel={t('Accessibility.breadcrumb')}
            items={[
              {
                label: t('navItems.Home'),
                href: homeHref,
              },
              {
                label: t('navItems.Articles'),
                href: articlesHref,
              },
              {
                label: t(
                  `articles-listing:articles.${contentId}.title` as never,
                ),
              },
            ]}
          />
          <h1 className="font-black text-[30px] tracking-[-0.03em] text-ink dark:text-dark-ink leading-[1.15] mb-4">
            {t(`articles-listing:articles.${contentId}.title` as never)}
          </h1>
          <div className="prose prose-lg dark:prose-invert prose-headings:font-black prose-headings:tracking-tight prose-a:text-cyan dark:prose-a:text-cyan prose-strong:font-extrabold mt-6">
            <ReactMarkdown>
              {t(`${contentId}:content`, { markdown: true })}
            </ReactMarkdown>
            <p
              className={`mt-6 text-xs text-ink-secondary dark:text-dark-ink2 text-center not-prose ${emphasisClass}`}
            >
              {t('SharedList.disclaimer')}
            </p>
          </div>
        </div>
      </article>
    </div>
  )
}
